import { Helmet } from 'react-helmet-async';
import { useCallback, useEffect, useRef, useState } from 'react';
// @mui
import { Button, Container, Stack, Typography } from '@mui/material';
// components
import { CabinetList } from '../sections/@dashboard/cabinet';
import { Link as RouterLink } from 'react-router-dom';
// mock
import AddButton from 'src/components/Button.js/AddBotton';
import { useParams, useLocation } from 'react-router-dom';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import CabinetModal from 'src/components/modal/Cabinet';
import Loader from 'src/components/loader/loader';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import Iconify from 'src/components/iconify';
import ChooseCabinetModal from 'src/components/modal/ChooseCabinetModal';
import crypt from 'src/utils/service/crypt';
import EmtyData from 'src/components/emty-data';

// ----------------------------------------------------------------------

export default function Canbinet() {
    const [visible, setVisible] = useState(false);
    const [visibleDel, setVisibleDel] = useState(false);
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const { t } = useTranslation();
    const params = useParams();
    const isEdit = useRef(false);
    const [data, setData] = useState({});
    const delFlags = useRef(false);
    const [deleleFlags, setDeleleFlags] = useState(false);
    const success = useRef(false);
    const [visibleConfigCabinet, setVisibleConfigCabinet] = useState(false);
    const [screenPermissions, setScreenPermissions] = useState({});
    const user = useRef({});

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        if (userData) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                user.current = data;
            } catch (error) {}
        }
    }, []);
    const location = useLocation();

    useEffect(() => {
        if (location.state?.openAdd) {
            isEdit.current = false;
            setVisible(true);
            setData({});
        }
    }, [location.state]);

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 600);
    }, [success.current]);

    const getData = useCallback(() => {
        if (getFlags) {
            return;
        }
        const InVal = [+params.idPermission, 999];
        sendRequest(serviceList.getAllCabinet, InVal, getDataResult, true, timeOutFunct, 40000);
    }, [success.current]);

    const getDataResult = (reqInfoMap, message) => {
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
            // console.log('Cabinet', message.proc_data.rows)
            setScreenPermissions(message.proc_data.rows[1].o_1[0][0]);
        }
    };

    const timeOutFunct = (reqInfo) => {
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    const handleDelete = () => {
        if (!data.id) return toast.error(t('error.system_error'));
        if (delFlags.current) {
            return;
        }
        setDeleleFlags(true);
        delFlags.current = true;
        const InVal = [+params.idPermission, data.id];
        sendRequest(serviceList.deleteCabinet, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setDeleleFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleDel(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleDel(false);
            getData();
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setDeleleFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };

    return (
        <>
            <Helmet>
                <title> {t('quan_ly_tu')}</title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1} flexWrap={'wrap'}>
                    <Typography variant="h4" sx={{ mb: 1 }}>
                        {t('quan_ly_tu')}
                    </Typography>

                    {user.current?.group_user !== '3' && (
                        <>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0} gap={1}>
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="ri:device-line" />}
                                    onClick={() => setVisibleConfigCabinet(true)}
                                >
                                    {t('config_cabinet')}
                                </Button>
                                {user.current?.group_user === '1' && (
                                    <Button
                                        variant="contained"
                                        startIcon={<Iconify icon="material-symbols-light:device-hub" />}
                                        component={RouterLink}
                                        to={`/home/manager-cabinet/${params.idPermission}/config-devices`}
                                    >
                                        {t('config_device')}
                                    </Button>
                                )}
                            </Stack>
                        </>
                    )}
                </Stack>
                <Breadcrumb paths={[{ label: t('quan_ly_tu'), url: '#', navigate: false }]} />

                <Loader loading={deleleFlags} />
                <CabinetModal
                    isEdit={isEdit.current}
                    idPermission={params.idPermission}
                    visible={visible}
                    dataUpdate={data}
                    fuctGet={getData}
                    setVisible={setVisible}
                />
                <ConfirmModal visible={visibleDel} setVisible={setVisibleDel} handleDelete={handleDelete} />
                <ChooseCabinetModal visible={visibleConfigCabinet} setVisible={setVisibleConfigCabinet} />
                {tableData.length > 0 ? (
                    <CabinetList
                        products={tableData}
                        setData={setData}
                        idPermission={params.idPermission}
                        functEdit={() => {
                            isEdit.current = true;
                            setVisible(true);
                        }}
                        getData={getData}
                        functDelete={() => setVisibleDel(true)}
                        screenPermissions={screenPermissions}
                    />
                ) : (
                    <EmtyData />
                )}
                {screenPermissions?.insert_permission === '1' && tableData.length > 0 ? (
                    <AddButton
                        onClick={() => {
                            isEdit.current = false;
                            setVisible(true);
                            setData({});
                        }}
                    />
                ) : (
                    ''
                )}
                {tableData.length === 0 && (
                    <AddButton
                        onClick={() => {
                            isEdit.current = false;
                            setVisible(true);
                            setData({});
                        }}
                    />
                )}
            </Container>
        </>
    );
}
